<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link } from "svelte-routing";
  
  export let block;
</script>

<div class="container">
  <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
    <h1 class="display-4 fw-normal">Pricing</h1>
    <p class="fs-5 text-muted">
      Quickly build an effective pricing table for your potential
      customers with this Bootstrap example. It’s built with default
      Bootstrap components and utilities with little
      customization.
    </p>
  </div>
  <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
    {#each blocklist(block, 'prices') as item}
    <div class="col">
      <div class="card mb-4 rounded-3 shadow-sm">
        <div class="card-header py-3">
          <h4 class="my-0 fw-normal">{text(item, 'plan')}</h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title">
            ${text(item, 'amount')}<small class="text-muted fw-light">/mo</small>
          </h1>
          <div>
            {@html richtext(item, 'features')}
          </div>
          <a href="{url(item, 'button')}" class="w-100 btn btn-lg btn-outline-primary" use:link>
            {text(item, 'button')}
          </a>
        </div>
      </div>
    </div>
    {/each}
  </div>
</div>
